import React from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Divider,
} from "antd";
import {
  TrophyOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const About = ({ content }) => {
  if (!content) {
    return null;
  }

  const metadata = content.metadata || {};
  const achievements = metadata.achievements || [];
  const title = content.title || "";
  const [titleStart, ...titleRest] = title.split(",");
  const values = metadata.values || [];
  const achievementIcons = [TrophyOutlined, TeamOutlined, ClockCircleOutlined, CheckCircleOutlined];
  const valueIcons = [CheckCircleOutlined, TeamOutlined, TrophyOutlined];

  return (
    <section id="about" className="content-section about-section" style={{ padding: "80px 40px", background: "#fff" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* ================= HERO ================= */}
        <Row gutter={[40, 40]} align="middle">
          <Col xs={24} md={12}>
            <Title level={2}>
              {titleStart}
              <span style={{ color: "#916847", display: "block" }}>
                {titleRest.join(",").trim()}
              </span>
            </Title>

            {content.subtitle && (
              <Paragraph style={{ fontSize: 16 }}>{content.subtitle}</Paragraph>
            )}

            {content.body && (
              <Paragraph style={{ fontSize: 16 }}>{content.body}</Paragraph>
            )}

            {/* Achievements */}
            {!!achievements.length && (
              <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
                {achievements.map((item, index) => {
                  const AchievementIcon = achievementIcons[index] || TrophyOutlined;

                  return (
                    <Col xs={12} key={item.text || item.label}>
                      <Card
                        variant={false}
                        style={{ textAlign: "center", borderRadius: 12 }}
                      >
                        <div
                          style={{
                            fontSize: 28,
                            color: item.color || "#916847",
                            marginBottom: 10,
                          }}
                        >
                          <AchievementIcon />
                        </div>

                        <Title level={4} style={{ margin: 0 }}>
                          {item.number || item.value}
                        </Title>

                        <Text type="secondary">{item.text || item.label}</Text>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </Col>

          {/* Image Section */}
          {content.image_url && (
          <Col xs={24} md={12}>
            <div style={{ position: "relative" }}>
              <img
                src={content.image_url}
                alt="Studio"
                loading="lazy"
                style={{
                  width: "100%",
                  borderRadius: 20,
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                }}
              />

              {metadata.badge && (
                <Card className="about-badge"
                  style={{
                    position: "absolute",
                    bottom: -20,
                    left: -20,
                    borderRadius: 16,
                  }}
                >
                  <Title level={5} style={{ margin: 0 }}>
                    {metadata.badge.title}
                  </Title>
                  <Text type="secondary">{metadata.badge.subtitle}</Text>
                </Card>
              )}
            </div>
          </Col>
          )}
        </Row>

        {/* ================= VALUES ================= */}
        {!!values.length && (
          <>
            <Divider style={{ margin: "80px 0" }} />
            {metadata.values_title && (
              <div style={{ textAlign: "center", marginBottom: 50 }}>
                <Title level={2}>{metadata.values_title}</Title>
              </div>
            )}

            <Row gutter={[32, 32]}>
              {values.map((value, index) => {
                const ValueIcon = valueIcons[index] || CheckCircleOutlined;

                return (
                  <Col xs={24} md={8} key={value.title}>
                    <Card style={{ borderRadius: 20, textAlign: "center" }}>
                      <ValueIcon style={{ fontSize: 40, color: "#916847" }} />
                      <Title level={4}>{value.title}</Title>
                      <Paragraph>{value.description}</Paragraph>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </>
        )}
      </div>
    </section>
  );
};

export default About;
